export const APP_NAME = 'DISCO'
export const PERSIST_STORE_NAME = 'discoStore'
export const REDIRECT_URL_KEY = 'redirectUrl'
